import {
  AnyZodObject,
  z,
  ZodDefault,
  ZodEffects,
  ZodError,
  ZodObject,
  ZodTypeAny,
} from "zod";

namespace UZod {
  export const predicate = <In, Out extends In>(
    fn: (value: In) => value is Out,
    message: string
  ): z.ZodType<Out, z.ZodTypeDef, In> => z.custom<Out>(fn, message);

  export const enforce = <T,>(
    fn: (value: any) => value is T,
    message: string
  ): z.ZodType<T, z.ZodTypeDef, T> => z.custom<T>(fn, message);

  export class Error extends globalThis.Error {
    constructor(
      source: ZodError,
      message = "Validation failed with the following issues"
    ) {
      super(
        `${message}:\n - ${source.issues
          .map((issue) => issue.message)
          .join("\n - ")}`,
        { cause: source }
      );
    }
  }

  export function findBase(schema: ZodTypeAny): ZodTypeAny {
    if ("unwrap" in schema) return findBase((schema.unwrap as any)());
    if (schema instanceof ZodEffects) return findBase(schema.innerType());
    if (schema instanceof ZodDefault) return findBase(schema._def.innerType);
    return schema;
  }

  export const findObject = <T extends ZodTypeAny>(
    schema: T
  ): AnyZodObject | undefined => {
    if (schema instanceof ZodObject) {
      return schema;
    }
    if (schema instanceof ZodEffects) {
      return findObject(schema._def.schema);
    }
  };
}

export default UZod;
